// すべてのクチコミページのクチコミのレイアウトを操作

const ID_ZV_MASTER = 'ZVListMaster'
document.addEventListener('DOMContentLoaded', () => {
  const elementZVMaster = document.getElementById(ID_ZV_MASTER)
  if (!elementZVMaster) return

  document.addEventListener('zvrendercomplete', () => {
    const elementsReview = elementZVMaster.getElementsByClassName(
      'zv-top-customer-review'
    )

    Array.from(elementsReview).forEach((element) => {
      const wrapper = document.createElement('div')
      wrapper.classList.add('t-page__review-wrapper')

      const elementItem = element.querySelector('.zv-item')

      // 画像を取得
      const elementImage = elementItem.querySelector('img')
      const imageUrl = elementImage?.src || ''
      const productHandle =
        imageUrl.match(/.*\/(products|files)\/(\d{13}).*/)?.[2] || ''
      const productUrl = productHandle ? `/products/${productHandle}` : ''

      if (elementImage) {
        const elImage = document.createElement('img')
        elImage.src = imageUrl

        if (productUrl) {
          const elementImageLink = document.createElement('a')
          elementImageLink.href = productUrl
          elementImageLink.classList.add('t-page__review-image')
          elementImageLink.appendChild(elImage)
          wrapper.prepend(elementImageLink)
        } else {
          const elementImageSpan = document.createElement('span')
          elementImageSpan.classList.add('t-page__review-image')
          elementImageSpan.appendChild(elImage)
          wrapper.prepend(elementImageSpan)
        }
      }

      // 商品名を取得
      const textTitle = elementItem.textContent
        .replace('レビュー対象商品：', '')
        .trim()
      const elementTitle = document.createElement('h2')

      if (productUrl) {
        // 商品画像がある場合画像URLから商品のハンドルを取得しリンクを設定する
        const elementTitleLink = document.createElement('a')
        elementTitleLink.href = productUrl
        elementTitleLink.textContent = textTitle
        elementTitle.appendChild(elementTitleLink)
      } else elementTitle.textContent = textTitle
      elementTitle.classList.add('t-page__review-title')
      element.prepend(elementTitle)

      elementItem.remove()

      element.parentNode.insertBefore(wrapper, element)
      wrapper.appendChild(element)

      const elementLoading = elementZVMaster.querySelector(
        '#ZVListMasterLoading'
      )
      elementLoading?.remove()
    })
  })
})
